// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DQXBx","option":"styles_option__3yv82","selected":"styles_selected__1c_IH"};